/**
 * @generated SignedSource<<cd7b062c55216310f6a3e69927b14872>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ApiKeyManager_apiKeys$data = {
  readonly apiKeys: ReadonlyArray<{
    readonly createdAt: string;
    readonly description: string;
    readonly expiresAt: string;
    readonly id: string;
    readonly lastUsedAt: string | null;
    readonly permission: {
      readonly read: {
        readonly everything: boolean;
        readonly queriesByCollection: any;
      };
      readonly remoteQuery: boolean;
      readonly write: {
        readonly everything: boolean;
        readonly queriesByCollection: any;
      };
    };
    readonly viewerCanDelete: boolean;
  }>;
  readonly " $fragmentType": "ApiKeyManager_apiKeys";
};
export type ApiKeyManager_apiKeys$key = {
  readonly " $data"?: ApiKeyManager_apiKeys$data;
  readonly " $fragmentSpreads": FragmentRefs<"ApiKeyManager_apiKeys">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "everything",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "queriesByCollection",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ApiKeyManager_apiKeys",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Apikey",
      "kind": "LinkedField",
      "name": "apiKeys",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "description",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "createdAt",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "lastUsedAt",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Permission",
          "kind": "LinkedField",
          "name": "permission",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "remoteQuery",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "PermissionRules",
              "kind": "LinkedField",
              "name": "read",
              "plural": false,
              "selections": (v0/*: any*/),
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "PermissionRules",
              "kind": "LinkedField",
              "name": "write",
              "plural": false,
              "selections": (v0/*: any*/),
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "viewerCanDelete",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "expiresAt",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "App",
  "abstractKey": null
};
})();

(node as any).hash = "0999fbfab14a689bae944ff1d2c244ff";

export default node;
